'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = RequiredAsterisk;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

require('./styles.css');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function RequiredAsterisk(_ref) {
  var required = _ref.required;

  if (required) {
    return _react2.default.createElement('abbr', {
      className: 'rainbow-required-asterisk',
      title: 'required'
    }, '*', ' ');
  }

  return null;
}

RequiredAsterisk.propTypes = {
  required: _propTypes2.default.bool.isRequired
};